import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { Space, ImpactStory } from '@shapeable/doing-co-types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ComponentPropsProvider, EntityTypeCardsProvider, ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayoutProps, ExplorerProvider, ExplorerTabs, SiteHeaderLayout, SiteHeaderProvider, SliceLayoutBoundary } from '@shapeable/ui';
import { DocumentCard } from './document-card';
import { ImpactStoryCard } from './impact-story-card';
const cls = classNames('impact-story-explorer-layout');

// -------- Types -------->

// -------- Props -------->

export type ImpactStoryExplorerLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity: ImpactStory;
};

export const ImpactStoryExplorerLayoutDefaultProps: Omit<ImpactStoryExplorerLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
  isAsideSticky: false,
  showAsideHeader: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    .shp--entity-banner {
      h2.shp--entity-value__name {
       font-size: ${theme.FONT_SIZE(20)};
      }
      .shp--cell-label {
        color: ${theme.COLOR('light')};
      }
    }
  `,
  landscape: css`
    .shp--entity-banner {
      h2.shp--entity-value__name {
       font-size: ${theme.FONT_SIZE(30)};
      }
    }
  `,
});

const HeaderStyles = breakpoints({
  base: css`
    margin-bottom: ${theme.UNIT(6)};
  `,
});

const TabsStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
    Tabs: styled(ExplorerTabs)`${TabsStyles}`,
};

export const ImpactStoryExplorerLayout: Shapeable.FC<ImpactStoryExplorerLayoutProps> = (props) => {
  const { className, entity } = props;

  return (
      <ExplorerProvider>
      <EntityTypeCardsProvider value={{
        Document: DocumentCard,
        ImpactStory: ImpactStoryCard,
      }}>
      <ComponentPropsProvider value={{ 
        EntityBanner: {
          maxHeight: 300,
          variant: 'image',
          showSubheader: true,
          useBackgroundColor: true,
          subHeaderBackgroundColor: 'primary',
          customAspectRatio: { base: 16 / 9, desktop: 21 / 9 },
          entityValueProps: { showImage: false, showOutlineNumber: false },
        },
      }}>
        <My.Container>
          <My.Header variant="light" />
          <My.Tabs useStickyStyle />
          <SliceLayoutBoundary boundary='none' >
            <My.Layout 
              entity={entity}
              className={cls.name(className)}
              stickyTopOffset={125}
              asideMaxWidth={800}
              asideIsOffset={false}
              showAsideHeader={false}
            />
          </SliceLayoutBoundary>
        </My.Container>
      </ComponentPropsProvider>
      </EntityTypeCardsProvider>
      </ExplorerProvider>

  )
};

ImpactStoryExplorerLayout.defaultProps = ImpactStoryExplorerLayoutDefaultProps;
ImpactStoryExplorerLayout.cls = cls;